/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var GoogleMap = {};

( function( $ ) {

	var Viewport = {};

	Viewport.documentWidth = function(){
	  var e = window, a = 'inner';
	  if (!('innerWidth' in window )) {
	    a = 'client';
	    e = document.documentElement || document.body;
	  }
	  return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};

	GoogleMap.getOptions = function( lat, lng ) {
		return {
			zoom: 15,
			scrollwheel: false,
			draggable: true,
			panControl: true,
			disableDefaultUI: false,
			center: new google.maps.LatLng( lat, lng )
		};
	};

	GoogleMap.load = function() {
		if( !$('#map_canvas').length ) {
			return;
		}

		var lat = $('#map_canvas').data('lat');
		var lng = $('#map_canvas').data('lng');

		var map = new google.maps.Map( document.getElementById( 'map_canvas' ), this.getOptions( lat, lng ) );

		new google.maps.Marker( {
			position: new google.maps.LatLng( lat, lng ),
			map: map
		} );
	};

	GoogleMap.height = function(){
		var windowHeight = ( $( window ).height() - '70' ) + 'px';

		if ( Viewport.documentWidth().width < 480 ) {
			$( '.contact-map' ).css({ 'height': windowHeight });
		}

	};

	$( document ).ready( function() {
		GoogleMap.load();
		GoogleMap.height();
	} );

} )( jQuery );
